{
  "$schema": "https://mux.run/theme.json",
  "name": "One Dark",
  "id": "one-dark",
  "light": {
    "palette": {
      "neutral": "#fafafa",
      "ink": "#383a42",
      "primary": "#4078f2",
      "accent": "#0184bc",
      "success": "#50a14f",
      "warning": "#c18401",
      "error": "#e45649",
      "info": "#986801",
      "diffAdd": "#489447",
      "diffDelete": "#d65145"
    },
    "overrides": {
      "text-weak": "#a0a1a7",
      "syntax-comment": "#a0a1a7",
      "syntax-keyword": "#a626a4",
      "syntax-string": "#50a14f",
      "syntax-primitive": "#4078f2",
      "syntax-variable": "#e45649",
      "syntax-property": "#0184bc",
      "syntax-type": "#c18401",
      "syntax-constant": "#986801",
      "syntax-operator": "#0184bc",
      "syntax-punctuation": "#383a42",
      "syntax-object": "#e45649",
      "markdown-heading": "#a626a4",
      "markdown-text": "#383a42",
      "markdown-link": "#4078f2",
      "markdown-link-text": "#0184bc",
      "markdown-code": "#50a14f",
      "markdown-block-quote": "#a0a1a7",
      "markdown-emph": "#c18401",
      "markdown-strong": "#986801",
      "markdown-horizontal-rule": "#a0a1a7",
      "markdown-list-item": "#4078f2",
      "markdown-list-enumeration": "#0184bc",
      "markdown-image": "#4078f2",
      "markdown-image-text": "#0184bc",
      "markdown-code-block": "#383a42"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#282c34",
      "ink": "#abb2bf",
      "primary": "#61afef",
      "accent": "#56b6c2",
      "success": "#98c379",
      "warning": "#e5c07b",
      "error": "#e06c75",
      "info": "#d19a66",
      "diffAdd": "#aad482",
      "diffDelete": "#e8828b"
    },
    "overrides": {
      "text-weak": "#5c6370",
      "syntax-comment": "#5c6370",
      "syntax-keyword": "#c678dd",
      "syntax-string": "#98c379",
      "syntax-primitive": "#61afef",
      "syntax-variable": "#e06c75",
      "syntax-property": "#56b6c2",
      "syntax-type": "#e5c07b",
      "syntax-constant": "#d19a66",
      "syntax-operator": "#56b6c2",
      "syntax-punctuation": "#abb2bf",
      "syntax-object": "#e06c75",
      "markdown-heading": "#c678dd",
      "markdown-text": "#abb2bf",
      "markdown-link": "#61afef",
      "markdown-link-text": "#56b6c2",
      "markdown-code": "#98c379",
      "markdown-block-quote": "#5c6370",
      "markdown-emph": "#e5c07b",
      "markdown-strong": "#d19a66",
      "markdown-horizontal-rule": "#5c6370",
      "markdown-list-item": "#61afef",
      "markdown-list-enumeration": "#56b6c2",
      "markdown-image": "#61afef",
      "markdown-image-text": "#56b6c2",
      "markdown-code-block": "#abb2bf"
    }
  }
}
